import React, { useEffect, useRef } from 'react';
import { useStorage } from '~Components/Storage';
import KivraInstance from './instance';

/**
 * This file handles syncing orders to Kivra for automatic
 * receipt sync to consumer's inboxes
 */
const Kivra = () => {
  const [storage, updateStorage] = useStorage();

  // We keep a ref pointing to storage here to ensure we dont
  // run updateStorage on outdata data (JS context issue)
  const storageRef = useRef(storage);

  useEffect(() => {
    storageRef.current = storage;
  }, [storage]);

  function handleExpired(orderId: string) {
    const orders = storageRef.current.ordersForKivraSync.filter((o) => o.order.id !== orderId);

    updateStorage({
      ordersForKivraSync: orders,
    });
  }

  return (
    <>
      {storage.ordersForKivraSync.map((data) => (
        <KivraInstance data={data} onExpired={handleExpired} />
      ))}
    </>
  );
};

export default Kivra;
